module.exports = __webpack_public_path__ + "static/media/TimelineIcon.13bf260b.svg";